import { useContext } from 'react'
import { utils, components } from '@digital-commerce/shared-utils'
import { bool, object } from 'prop-types'
import { Spacer } from '@telus-uds/components-web'
import { ResponsiveCard } from '../StyledContainers'

import localeContext from '../../../contexts/Locale'
import useTranslate from '../../../hooks/useTranslate'

import CartItem, { BasicInfo, ActionBar, OfferDetailsContainer } from '../../molecules/CartItem'
import { getChangeUrl, getOverriddenAttributes, getSubHeading } from './SmartHomeSecurity/utils'
import { buildContractTermLabel, getHSAppliedPromoCodeText } from '../../../utils/display'
import useFeatureFlags from '../../../hooks/useFeatureFlags'
import OfferDetails from './OfferDetails'
import { BUSINESS_CHANGE_URL } from './SecureBusiness/utils'
import { transformCancellationFeeContent } from '../../../utils/cart'

const { getItemOneTimePrice, getMonthlyTotalPrice } = utils.cart
const { WithLegal } = components

const Security = ({ securityService, cart, isRemoveButtonHidden, isSecureBusiness }) => {
  const translate = useTranslate()
  const { data: featureFlags } = useFeatureFlags()
  const { lang } = useContext(localeContext)

  const subHeading = isSecureBusiness ? 'secureBusiness' : getSubHeading(securityService)
  const changeUrl = isSecureBusiness ? BUSINESS_CHANGE_URL : getChangeUrl(securityService)
  const dueTodaySubTotal = getItemOneTimePrice(securityService)?.subTotal || 0
  const { subTotal: monthlySubTotal } = getMonthlyTotalPrice(securityService) || {}
  const term = buildContractTermLabel(translate, securityService)
  const attributes = getOverriddenAttributes(securityService, cart, translate, featureFlags)
  const appliedPromoCode = getHSAppliedPromoCodeText(securityService, featureFlags, cart)

  // we use this slug to avoid duplicate t&c item as sbs wln items also uses this slug for rental equipment return
  const rentalEquipmentReturnContent = translate('rentalEquipmentReturnSlug')
  const earlyCancelChargeContent = translate('earlyCancelChargeSlug')

  const termsAndConditions = isSecureBusiness ? (
    <WithLegal
      content={earlyCancelChargeContent + rentalEquipmentReturnContent}
      onReceiveContent={transformCancellationFeeContent(securityService, lang)}
      copy={lang}
    />
  ) : undefined

  // If it's a SmartWear service, override the item image to use the device image instead
  const smartwearDevice = securityService.items?.find((item) =>
    item.tags?.includes('smartwear-device')
  )

  return (
    <>
      <ResponsiveCard variant={{ border: 'line', padding: 'custom' }}>
        <CartItem cartItem={securityService}>
          <BasicInfo
            subHeading={translate(subHeading)}
            dueTodaySubTotal={dueTodaySubTotal}
            monthlySubTotal={monthlySubTotal}
            changeUrl={changeUrl}
            term={term}
            attributesOverride={attributes}
            appliedPromoCodeText={appliedPromoCode}
            termsAndConditions={termsAndConditions}
            itemImageOverride={smartwearDevice}
          />
          <ActionBar isShowDetailsCtaHidden={false} isRemoveButtonHidden={isRemoveButtonHidden} />
          <OfferDetailsContainer>
            <OfferDetails
              securityService={securityService}
              cart={cart}
              isSecureBusiness={isSecureBusiness}
            />
          </OfferDetailsContainer>
        </CartItem>
      </ResponsiveCard>
      <Spacer space={5} />
    </>
  )
}

export default Security

Security.propTypes = {
  securityService: object.isRequired,
  cart: object.isRequired,
  isRemoveButtonHidden: bool,
  isSecureBusiness: bool
}

Security.defaultProps = {
  isRemoveButtonHidden: false,
  isSecureBusiness: false
}
